let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1aY8e")).then(() => parcelRequire('8gkVf'));